import React from 'react';
import { useAuth } from '../context/shared/AuthContext';
import PatientDashboard from '../pages/PatientDashboard';
import TherapistConsole from '../pages/TherapistConsole';

const RoleBasedDashboard: React.FC = () => {
    const { user } = useAuth();

    // Determine user role and render appropriate dashboard
    const userRole = user?.role || 'patient';
    
    if (userRole === 'therapist' || userRole === 'therapist_asst' || userRole === 'admin') {
        return <TherapistConsole />;
    }
    
    // Default to patient dashboard
    return <PatientDashboard />;
};

export default RoleBasedDashboard;
